import { Checkbox, FormControlLabel } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';

import { TPatientMriUploadModal, TPatientMriUploadModalResponse } from './PatientMriUploadModal.types';

import API from '../../API';
import { Colors } from '../../const';
import AdornmentTooltip from '../AdornmentTooltip/AdornmentTooltip';

const PatientMriUploadModal: FC<TPatientMriUploadModal> = ({ dataset, removeModal, removeModalLight, setIsDisabled, isDisabled }) => {
  const { onAccept, onReject } = dataset;
  const [isLoading, setIsLoading] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [isIdExistInDb, setIsIdExistInDb] = useState(false);
  const isIdExistInMri = !!dataset.hospitalPatientIdNew;

  useEffect(() => {
    setIsDisabled(true);
    API.checkHospitalPatientId<TPatientMriUploadModalResponse>(dataset.hospitalPatientIdNew || '').then(({ data }) => {
      setIsIdExistInDb(data.data.result);
      setIsDisabled(false);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <div className='react-components-pmum__loading'>
          <div className='lds-spinner'>
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      ) : null}
      <div className='react-components-pmum'>
        <h3>院内IDが異なります</h3>
        <p>
          既に登録されている院内IDと、DICOMに登録されているIDが異なります。
          <br />
          アップロードを続けますか？
        </p>
        <div className='react-components-pmum__field-wrapper'>
          <div className='react-components-pmum__field'>
            <span style={{ position: 'relative' }}>
              {dataset.hospitalPatientIdAuto ? (
                <div style={{ position: 'absolute', left: '-40%', top: '50%', transform: 'translateY(-50%)' }}>
                  <AdornmentTooltip key='warn' type='warning' title={<>自動生成されたIDです。運用上、院内で利用されているIDに変更してください。</>} />
                </div>
              ) : null}
              現在のID：
            </span>
            <span>DICOMのID：</span>
          </div>
          <div className='react-components-pmum__field'>
            <span>{dataset.hospitalPatientId}</span>
            <span>{dataset.hospitalPatientIdNew}</span>
          </div>
          <div className='react-components-pmum__field react-components-pmum__field--name'>
            <span>({dataset.patientName})</span>
            <span>({dataset.patientNameNew})</span>
          </div>
        </div>

        <FormControlLabel
          sx={{
            width: 'fit-content',
            marginLeft: '2rem',
            alignSelf: 'center',
            '.MuiFormControlLabel-label': {
              color: isIdExistInDb ? `${Colors.red} !important` : isIdExistInMri ? '' : `${Colors.red} !important`,
            },
          }}
          control={
            <Checkbox
              color='primary'
              disabled={isIdExistInDb || !isIdExistInMri}
              checked={isChecked}
              indeterminate={isIdExistInDb || !isIdExistInMri}
              onChange={() => {
                setIsChecked((prev) => !prev);
              }}
            />
          }
          label={
            isIdExistInDb
              ? '※このDICOMのIDは、すでに院内IDとして利用している受診者がいます'
              : isIdExistInMri
              ? '院内IDをDICOMのIDに書き換える'
              : '新しいDICOMにIDがありません。上書きできません。'
          }
        />

        <div className='react-components-pmum__btn-wrapper'>
          <button
            disabled={isDisabled}
            className='btn btn--main'
            type='button'
            onClick={() => {
              if (onAccept)
                onAccept(
                  () => {},
                  () => {},
                  isChecked,
                );
              removeModalLight();
            }}
          >
            アップロード
          </button>
          <button
            disabled={isDisabled}
            className='btn btn--additional'
            type='button'
            onClick={() => {
              if (onReject) onReject(removeModal);
            }}
          >
            キャンセル
          </button>
        </div>
      </div>
    </>
  );
};

export default PatientMriUploadModal;
